'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css2 = require('antd/lib/radio/style/css');

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _css3 = require('antd/lib/select/style/css');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _css4 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 客户基本信息修改按钮及弹出表单
                                                                                                                                                                                                                                                                  */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _modal_form = require('./modal_form');

var _modal_form2 = _interopRequireDefault(_modal_form);

var _with_levels = require('../containers/with_levels');

var _with_levels2 = _interopRequireDefault(_with_levels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;
var Option = _select2.default.Option;
var RadioGroup = _radio2.default.Group;

var UserEdit = _react2.default.createClass({
    displayName: 'UserEdit',
    onOk: function onOk(form) {

    },
    render: function render() {
        var _props = this.props,
            user = _props.user,
            levels = _props.levels,
            form = _props.form;
        var getFieldDecorator = form.getFieldDecorator;

        var formItemLayout = {
            labelCol: {
                span: 6
            },
            wrapperCol: {
                span: 14
            }
        };
        return _react2.default.createElement(
            _modal_form2.default,
            { form: form, onOk: this.onOk.bind(this, form), btnText: '\u4FEE\u6539', title: '\u5BA2\u6237\u57FA\u672C\u4FE1\u606F\u4FEE\u6539' },
            _react2.default.createElement(
                _form2.default,
                null,
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, {
                        label: '\u5BA2\u6237\u540D\u79F0',
                        required: true
                    }),
                    getFieldDecorator('name', {
                        rules: [{ required: true, message: '请输入客户名称!' }],
                        initialValue: user.name
                    })(_react2.default.createElement(_input2.default, null))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, {
                        label: '\u5BA2\u6237\u7B49\u7EA7',
                        required: true
                    }),
                    getFieldDecorator('level', {
                        rules: [{ required: true, message: '请选择客户等级!' }],
                        initialValue: user.level
                    })(_react2.default.createElement(
                        _select2.default,
                        { placeholder: '\u8BF7\u9009\u62E9\u5BA2\u6237\u7B49\u7EA7' },
                        levels.items.map(function (level) {
                            return _react2.default.createElement(
                                Option,
                                { key: level.key, value: level.key },
                                level.key
                            );
                        })
                    ))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, {
                        label: '\u8D1F\u8D23\u4EBA\u59D3\u540D',
                        required: true
                    }),
                    getFieldDecorator('manager', {
                        rules: [{ required: true, message: '请输入负责人姓名!' }],
                        initialValue: user.manager
                    })(_react2.default.createElement(_input2.default, null))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, {
                        label: '\u8D1F\u8D23\u4EBA\u624B\u673A\u53F7',
                        required: true
                    }),
                    getFieldDecorator('mobile', {
                        rules: [{ required: true, message: '请输入负责人手机号!' }, { pattern: /^1[34578]\d{9}$/, message: '手机号格式错误' }],
                        initialValue: user.mobile
                    })(_react2.default.createElement(_input2.default, null))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, {
                        label: '\u5BA2\u6237\u72B6\u6001',
                        required: true
                    }),
                    getFieldDecorator('status', {
                        rules: [{ required: true, message: '请输入客户状态!' }],
                        initialValue: user.status
                    })(_react2.default.createElement(
                        RadioGroup,
                        null,
                        _react2.default.createElement(
                            _radio2.default,
                            { value: '\u6FC0\u6D3B' },
                            '\u6FC0\u6D3B'
                        ),
                        _react2.default.createElement(
                            _radio2.default,
                            { value: '\u7981\u7528' },
                            '\u7981\u7528'
                        )
                    ))
                )
            )
        );
    }
});

exports.default = (0, _with_levels2.default)(_form2.default.create()(UserEdit));


//////////////////
// WEBPACK FOOTER
// ./src/js/components/user_edit.js
// module id = 1327
// module chunks = 0